import { Injectable } from '@angular/core';

import { Action, Selector, State, StateContext } from '@ngxs/store';

import { ResetReportsState, UpdateReportsActivePage, UpdateReportsPageSize, UpdateReportsSearchQuery, UpdateReportsSort } from '@state-management/actions';

import { SortEntries } from '@data';

import { TableState } from '@models';

export interface StandardReportsStateModel extends TableState { }

const STANDARD_REPORTS_STATE_DEFAULT: StandardReportsStateModel = {
    pageSize: SortEntries()[0],
    activePage: 0,
    sort: {
        prop: 'title',
        direction: 'asc',
        name: 'Title',
        default: true
    },
    searchQuery: '',
    filtered: false
};

@State<StandardReportsStateModel>({
    name: 'standardReports',
    defaults: STANDARD_REPORTS_STATE_DEFAULT
})

@Injectable()
export class StandardReportsState {

    @Selector()
    static getReportsState(state: StandardReportsStateModel): StandardReportsStateModel {
        return state;
    }

    @Action(UpdateReportsPageSize)
    public updateReportsPageSize(ctx: StateContext<StandardReportsStateModel>, action: UpdateReportsPageSize) {
        ctx.patchState({
            ...ctx.getState(),
            pageSize: action.pageSize,
            filtered: true
        });
    }

    @Action(UpdateReportsSearchQuery)
    public updateReportsSearchQuery(ctx: StateContext<StandardReportsStateModel>, action: UpdateReportsSearchQuery) {
        ctx.patchState({
            ...ctx.getState(),
            searchQuery: action.searchQuery,
            filtered: true
        });
    }

    @Action(UpdateReportsActivePage)
    public updateReportsActivePage(ctx: StateContext<StandardReportsStateModel>, action: UpdateReportsActivePage) {
        ctx.patchState({
            ...ctx.getState(),
            activePage: action.activePage,
            filtered: true
        });
    }

    @Action(UpdateReportsSort)
    public updateReportsSort(ctx: StateContext<StandardReportsStateModel>, action: UpdateReportsSort) {
        ctx.patchState({
            ...ctx.getState(),
            activePage: 0,
            sort: {
                prop: action.sort.prop,
                direction: action.sort.direction,
                name: action.sort.name,
                default: false
            },
            filtered: true
        });
    }

    @Action(ResetReportsState)
    public resetReportsState(ctx: StateContext<StandardReportsStateModel>, action: ResetReportsState) {
        ctx.setState(STANDARD_REPORTS_STATE_DEFAULT);
        if (action.table) {
            action.table.onColumnSort({ sorts: [{ prop: STANDARD_REPORTS_STATE_DEFAULT.sort.prop, dir: STANDARD_REPORTS_STATE_DEFAULT.sort.direction }] });
        }
    }
}